(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coirology-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coi-gallery-controls')) {
    customElements.define('coi-gallery-controls', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.gallery = this.closest('media-gallery');
        this.thumbnails = this.gallery?.querySelector('[id^="GalleryThumbnails"]');
        if (!this.thumbnails) return;
        this.buttons = Array.from(this.thumbnails.querySelectorAll('[data-target] button'));
        if (this.buttons.length < 2) return;
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.hidden = false;
        this.querySelector('[data-total]').textContent = this.buttons.length;
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-direction]');
          if (!control || control.disabled) return;
          const selected = this.buttons.findIndex(button => button.getAttribute('aria-current') === 'true');
          const index = Math.max(0, selected) + Number(control.dataset.direction);
          this.buttons[index]?.click();
        }, { signal: this.controller.signal });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.thumbnails, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
        this.update();
      }
      update() {
        const index = Math.max(0, this.buttons.findIndex(button => button.getAttribute('aria-current') === 'true'));
        this.querySelector('[data-current]').textContent = index + 1;
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.buttons.length - 1;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
